module.exports = __webpack_public_path__ + "static/sample-14-2ed8f4f857f811636c8cde0bac7fd88a.png";